import { HostListener } from '@angular/core';
import { FormGroup } from '@angular/forms';

export abstract class FormValidateComponent {
  isSubmitted = false;
  inputForm: FormGroup;
  browserIE: any;

  abstract createForm();

  abstract onSubmit();

  clearForm() {
    this.inputForm.reset();
    this.inputForm.updateValueAndValidity();
    this.inputForm.markAsUntouched();
  }

  resetSubmitted() {
    this.isSubmitted = false;
  }

  @HostListener('submit') eventSubmit() {
    this.isSubmitted = true;
  }
}
